import type { UserCentricsSmartDataProtectorSettings } from './types/google'
import { useLocationStore } from '@shared/global-store/stores/location/location'

declare global {
  interface Window {
    UC_UI_DOMAINS?: {
      crossDomainConsentSharingIFrame: string
    }
    uc: {
      setServiceAlias: (props: object) => void
    }
  }
}

const addHeadAsyncScript = (callback: (script: HTMLScriptElement) => void) => {
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.async = true

  callback(script)

  if (document.querySelector(`script[src="${script.src}"]`)) {
    return
  }

  document.head.appendChild(script)

  return script
}

export const addGTMScript = (gtmId: string) =>
  addHeadAsyncScript((script) => {
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`
    script.onload = () => {
      window.dataLayer.push({
        event: 'gtm.js',
        'gtm.start': new Date().getTime(),
        'gtm.uniqueEventId': 0,
      })
    }
  })

export const addUsercentricsScript = (
  usercentricsId: string,
  rulesetId?: string,
  crossDomainConsentSharingIFrame?: string,
  ucSdpSettings?: UserCentricsSmartDataProtectorSettings
) => {
  const locationStore = useLocationStore()

  if (crossDomainConsentSharingIFrame) {
    window.UC_UI_DOMAINS = {
      crossDomainConsentSharingIFrame,
    }
  }

  addHeadAsyncScript((script) => {
    script.id = 'usercentrics-cmp'
    script.src = 'https://web.cmp.usercentrics.eu/ui/loader.js'
    script.setAttribute('data-settings-id', usercentricsId)
    script.setAttribute('data-language', locationStore.locale)
    if (rulesetId) {
      script.setAttribute('data-ruleset-id', rulesetId)
    }
  })
  addHeadAsyncScript((script) => {
    script.type = 'application/javascript'
    script.src =
      'https://privacy-proxy.usercentrics.eu/latest/uc-block.bundle.js'
    script.async = false
    script.onload = () => {
      if (typeof window.uc !== 'undefined' && ucSdpSettings) {
        window.uc.setServiceAlias(ucSdpSettings.serviceAliases || {})
      }
    }
  })
}
